import React from 'react';
import { FormattedMessage } from 'react-intl';
import { H2, NamedLink } from '../../../components';
import Creator1Image from '../../AboutUsPage/images/michael.jpeg';
import Creator2Image from '../../AboutUsPage/images/jack.jpeg';

import css from './ExpertHelp.module.css';
import classNames from 'classnames';

const ExpertHelp = props => {
  const { className } = props;

  return (
    <div className={classNames(css.root, className)}>
      <H2 as="h2">
        <FormattedMessage id="OrderPanel.expertHelpTitle" />
      </H2>
      <p>
        <FormattedMessage id="OrderPanel.expertHelpText" />
      </p>
      <div className={css.images}>
        <div className={css.imgContainer}>
          <img src={Creator1Image} alt="" />
        </div>
        <div className={css.imgContainer}>
          <img src={Creator2Image} alt="" />
        </div>
      </div>
      <NamedLink name="ContactUsPage" className={css.contactUsLink}>
        <FormattedMessage id="OrderPanel.expertHelpContact" />
      </NamedLink>
    </div>
  );
};

export default ExpertHelp;
